module.exports = __webpack_public_path__ + "media/images/neonomics-2d45065cfcfe08314ab53694e8a28874.svg";